const REGEX = {
  ONLY_DIGITS: /^\d*$/,
};

export default REGEX;